import React from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";

import CreatableSelect from "react-select/creatable";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Box from "@material-ui/core/Box";

import { useStyles, theme, errorTheme, GreenCheckbox } from "./style";
import "./styles.css";

const Selector = ({
  isClearable,
  isSearchable,
  options,
  label,
  onChange,
  width,
  isMulti,
  onToggle1,
  onToggle2,
  toggle1Text,
  toggle2Text,
  defaultValue,
  checked1,
  inputValue,
  components,
  checked2,
  placeholder,
  isCreatable,
  onInputChange,
  menuIsOpen,
  closeMenuOnSelect,
  isDisabled,
  isOptionDisabled,
  onBlur,
  value,
  onKeyDown,
  className,
  inputId,
  error
}) => {
  const animatedComponents = makeAnimated();
  const classes = useStyles();

  return (
    <Box className={classes.selectorBox}>
      <Box width={width}>
        {label && <h4>{label}</h4>}
        {isCreatable ? (
          <CreatableSelect
            components={components}
            inputValue={inputValue}
            isClearable={isClearable}
            isDisabled={isDisabled}
            isOptionDisabled={isOptionDisabled}
            defaultValue={defaultValue}
            menuIsOpen={menuIsOpen}
            width={width}
            className={className}
            onBlur={onBlur}
            theme={error ? errorTheme : theme}
            isMulti={isMulti}
            onChange={onChange}
            onInputChange={onInputChange}
            onKeyDown={onKeyDown}
            placeholder={placeholder}
            value={value}
            inputId={inputId}
            data-cy={inputId}
          />
        ) : (
            <>
              <Select
                closeMenuOnSelect={closeMenuOnSelect}
                defaultValue={defaultValue}
                value={value}
                isDisabled={isDisabled}
                isOptionDisabled={isOptionDisabled}
                components={animatedComponents}
                isMulti={isMulti}
                width={width}
                theme={theme}
                isClearable={isClearable}
                isSearchable={isSearchable}
                onChange={onChange}
                placeholder={placeholder}
                classNamePrefix="react-select"
                options={options}
                noOptionsMessage={() => "Não há dados"}
                inputId={inputId}
                data-cy={inputId}
              />
              {toggle1Text && (
                <FormControlLabel
                  control={
                    <GreenCheckbox
                      checked={checked1}
                      onChange={onToggle1}
                      name="checkedG"
                    />
                  }
                  label={toggle1Text}
                />
              )}
              {toggle2Text && (
                <FormControlLabel
                  control={
                    <GreenCheckbox
                      checked={checked2}
                      onChange={onToggle2}
                      name="checkedG"
                    />
                  }
                  label={toggle2Text}
                />
              )}
            </>
          )}
      </Box>
    </Box>
  );
};

export default Selector;
